<div *ngIf="isDateInFuture()" class="scenario-select" [class.shift-right]="sidebarIsOpen">
  <label for="scenario-select">{{ 'MAP.SCENARIO.TITLE' | translate }}</label>
  <div class="custom-select-wrapper">
    <select #scenarioSelect id="scenario-select" class="custom-select" [(ngModel)]="selectedScenario" (change)="onScenarioChange($event)">
      <option [ngValue]="null" disabled selected>{{ 'MAP.SCENARIO.SELECT' | translate }}</option>
      <option *ngFor="let scenario of scenarios" [ngValue]="scenario.value">
        {{ scenario.key }}
      </option>
    </select>
  </div>
  
</div>
